import { PlusOutlined } from "@ant-design/icons";
import { Button, Card, Col, Flex, Layout, Modal, Table, TableProps } from "antd";
import { ColumnsType } from "antd/es/table";
import { get, toNumber } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ActionContent from "src/components/common/ActionContent";
import ModalDeleteConfirm from "src/components/common/ModalDeleteConfirm";
import { apiCaller, cancelListToken } from "src/util/apiCaller";
import { reDataForTable } from "src/util/Commom";
import { MessageStatusError } from "src/util/MessageStatus";

interface Data {
  key: React.Key;
  tenQuyen: string;
}

const Quyen = ({ status }: any) => {
  const { isActive } = status;
  const [isLoadTable, setIsLoadTable] = useState<boolean>(false);
  const [datatable, setDatatable] = useState([]);
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const pageSize = 10;
  const navigate = useNavigate();

  useEffect(() => {
    if (isActive) {
      getListData(activePage);
    } else {
      navigate("/error/401");
    }
  }, []);

  useEffect(() => {
    return () => {
      cancelListToken(["listQuyen"]);
    };
  }, []);

  /**
   * getListData: gọi danh sách quyền
   * @param {number} activePage
   * @memberof Quyen
   */
  const getListData = async (activePage: number) => {
    setIsLoadTable(true);
    const configAPI = {
      url: `api/quyens?keyword=&page=${activePage}&size=${pageSize}`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listQuyen"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = reDataForTable(
          get(response.data, "content", []),
          activePage,
          pageSize
        );
        setDatatable(data as any);
        setTotal(get(response.data, "totalElements", 0));
        setIsLoadTable(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setIsLoadTable(false);
      }
    } finally {
      setIsLoadTable(false);
    }
  };

  const columns: ColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "key",
      key: "key",
      width: "5%",
      align: "center",
      render: (e: any) => {
        return e;
      }
    },
    { title: "Tên quyền", dataIndex: "tenQuyen", key: "tenQuyen",
      render: (text, record) => renderTitle(text, record)
     },
    {
      title: "Hành động",
      dataIndex: "",
      key: "x",
      align: "center",
      width: "10%",
      render: (item: any) => actionContent(item)
    }
  ];

   /**
   * renderTitle: hiển thị màu title table
   * @param {String} text
   * @param {object} record
   * @param {String} title
   * @memberof LoaiTaiLieu
   */
   const renderTitle = (text: any, record: any) => (
    <span
      onClick={() => onClickInfo(record)}
      style={{ cursor: "pointer", color: "#0065ff" }}
      title="Xem chi tiết"
    >
      {text}
    </span>
  );

  const onClickInfo = (record: any) => {
    Modal.info({
      title: "Chi tiết quyền",
      content: (
        <div>
          <p>
            <b>Tên quyền:</b> {record.tenQuyen}
          </p>
        </div>
      ),
      okText: "Đóng",
      onOk() {}
    });
  };

  /**
   * actionContent: hành động trên bảng
   * @param {object} item
   * @memberof Quyen
   */
  const actionContent = (item: object) => {
    return (
      <ActionContent
        onDeleteItem={() => deleteItemFunc(item)}
        onEditItem={() => handleRedirect("edit", item)}
      />
    );
  };

  /**
   * deleteItemFunc: Xoá item theo item
   * @param {object} item
   * @returns
   * @memberof Quyen
   */
  const deleteItemFunc = (item: object) => {
    ModalDeleteConfirm(deleteItemAction, item);
  };

  /**
   * deleteItemAction: Xóa item
   * @param {object} item
   * @memberof Quyen
   */
  const deleteItemAction = async (item: any) => {
    const config = {
      url: `api/quyens/${item.id}`,
      apiType: "DELETE",
      value: null,
      method: "DELETE",
      getName: "deleteListQuyen"
    };
    const response = await apiCaller(config);
    try {
      if (response?.status === 200 || response?.status === 201) {
        const dataPage = total - (activePage - 1) * pageSize;
        const page = dataPage <= 1 && total !== 1 ? activePage - 1 : activePage;
        getListData(page);
        setIsLoadTable(true);
      } else {
        MessageStatusError(toNumber(response?.status));
        setIsLoadTable(false);
      }
    } catch (error) {
      setIsLoadTable(false);
      // Xử lý lỗi khi lưu dữ liệu không thành công
    }
  };

  /**
   * handleRedirect: Chuyển trang thêm mới và chỉnh sửa
   * @param {string} type
   * @param {object} item
   * @memberof Quyen
   */
  const handleRedirect = (type = "", item: any) => {
    let pathname = "/quan-tri/quyen";
    switch (type) {
      case "new":
        pathname += "/them-moi/";
        break;
      case "edit":
        pathname += `/${item.id}/chinh-sua/`;
        break;
      default:
        break;
    }
    navigate(pathname, { state: { itemData: item } });
  };

  /**
   * handleTableChange: chuyển trang
   * @param {number} pagination
   * @memberof Quyen
   */
  const handleTableChange: TableProps["onChange"] = (pagination) => {
    const activePage = pagination.current as number;
    getListData(activePage);
    setActivePage(activePage);
  };

  return (
    <Layout>
      <Flex justify="space-between" align="center">
        <h3 style={{ color: "black", fontSize: 20 }}>Quyền</h3>
        <Button
          className="heading-button-addnew btn"
          type="primary"
          onClick={() => handleRedirect("new", null)}
          icon={<PlusOutlined />}
        >
          Thêm mới
        </Button>
      </Flex>
      <Card>
        <Table
          rowKey={"id"}
          bordered
          columns={columns}
          className="qti-table-wrapper gx-table-responsive"
          dataSource={datatable}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "qti-table-row-background" : ""
          }
          size="middle"
          pagination={{
            current: activePage,
            pageSize,
            total,
            showSizeChanger: false,
            showQuickJumper: false,
            showTotal: (total) =>
              pageSize <= total
                ? `Hiển thị ${pageSize} trong tổng ${total}`
                : `Tổng ${total}`
          }}
          loading={isLoadTable}
          onChange={handleTableChange}
        />
      </Card>
    </Layout>
  );
};
export default Quyen;
